export default "__VITE_ASSET__DwLHITzD__"